import { InputHTMLAttributes } from 'react';
import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

type DatePickerProps = InputHTMLAttributes<HTMLInputElement> & {
  marginTop?: boolean;
  width?: string;
  error?: boolean;
  emptyValue?: boolean;
};

export const DatePickerContainer = styled.div<DatePickerProps>`
  width: ${(props) => props.width ?? '50%'};
`;

export const DatePickerInput = styled.input<DatePickerProps>`
  margin-top: ${(props) => (props.marginTop ? '8px' : '0')};
  height: 40px;
  width: 100%;
  border: solid 1px
    ${(props) =>
      props.error
        ? props.theme.atlas.semantic.color.action.destructive.default
        : props.theme.atlas.semantic.color.outline.default};
  border-radius: 3px;
  padding: 8px 8px 8px 16px;
  ${({ disabled }) => (!disabled ? `cursor: pointer;` : 'cursor: not-allowed;')}
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  background-color: ${(props) =>
    props.disabled
      ? props.theme.atlas.semantic.color.surface.subtle
      : props.theme.atlas.semantic.color.surface.default};

  &:focus {
    outline: none;
    box-shadow: ${(props) => props.theme.atlas.semantic.shadow.focus};
  }
  @supports (-webkit-hyphens: none) {
    ${({ emptyValue }) => emptyValue && `color: rgba(0, 0, 0, 0.2);`}
  }
`;

export const DatePickerLabel = styled.label`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;
